onLoad(() => {
    // Do not load drift if the property is set
    if ('DO_NOT_LOAD_LINKEDIN' in window) {
        return;
    }
    window._linkedin_data_partner_id = "94558";
    var s = document.getElementsByTagName("script")[0];
    var b = document.createElement("script");
    b.type = "text/javascript";
    b.async = true;
    b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
    s.parentNode.insertBefore(b, s);
});
